import React from 'react';
import { formatToMoney } from 'utils';
import { Icon, Icons } from './Icon';
import Button from './Form/Button';
import { Link } from 'react-router-dom';

type Props = {
  iWillLogo: string;
  iWillPrice: number;
  iWillPackages: { title: string; info: string }[];
  iWillPlanId: number;
  isRecommended: boolean;
  isUseLink?: boolean;
  onPlanSelect?: () => void;
  isSelectedPlan?: boolean;
  onSubmit?: () => void;
};

export default function IWillPlan({
  iWillLogo,
  iWillPrice,
  iWillPackages,
  iWillPlanId,
  isRecommended,
  isUseLink = true,
  onPlanSelect,
  isSelectedPlan,
  onSubmit
}: Props) {
  return (
    <div className="flex flex-col items-center gap-y-2">
      {isRecommended ? (
        <Button
          variant="primary"
          size="md"
          className="mt-10 w-full rounded-t-[10px] p-[0.1rem]"
          label="RECOMMENDED"
          type="button"
        ></Button>
      ) : (
        <div className="h-[5.2rem]"></div>
      )}
      <div
        className={`flex h-[835px] cursor-pointer flex-col items-center justify-between rounded-[10px] border-[3px] ${
          isSelectedPlan ? 'border-[#FF6606]' : 'border-[#FF660626]'
        }  px-5 py-20 pb-10`}
        onClick={onPlanSelect}
      >
        <div className="flex flex-col">
          <div className="flex flex-col items-center">
            <img src={iWillLogo} className="w-16" />
            <p className="my-10 text-center font-circular text-3xl font-semibold">
              {formatToMoney(iWillPrice)}
            </p>
            <div
              className={`mb-10 w-3/4 border-[2px] ${
                isRecommended ? 'border-[#FF6606]' : 'border-[#35353533]'
              }`}
            />
          </div>
          {iWillPackages.map(packages => (
            <div
              key={packages.title}
              className="mt-5 flex items-center justify-between gap-10"
            >
              <div className="flex items-center gap-2">
                <p className="font-circular text-lg font-bold text-[#353535]">
                  {packages.title}
                </p>
                {/* <Icon name={Icons.Info} fill="#FF6600" /> */}
              </div>
              <Icon name={Icons.CheckMark} />
            </div>
          ))}
        </div>
        {isUseLink ? (
          <Link to={`/get-started/setup-account/${iWillPlanId}`}>
            <Button
              variant="primary"
              size="md"
              className="w-[7rem] rounded p-[0.1rem]"
              label="Get Started"
            ></Button>
          </Link>
        ) : (
          <Button
            variant="primary"
            size="md"
            className="w-[7rem] rounded p-[0.1rem]"
            label="Get Started"
            type="button"
            onClick={onSubmit}
          ></Button>
        )}
      </div>
    </div>
  );
}
